@if (visible) {
  <app-confirm-action-modal
    title="Pause Subscription"
    [confirmLabel]="confirmLabel"
    cancelButtonClass="btn-outlined"
    [busy]="busy"
    [confirmDisabled]="!!rangeError"
    busyLabel="Pausing..."
    [closeOnOverlayClick]="false"
    [mobileSheet]="false"
    testId="pause-subscription-modal"
    (confirm)="onConfirm()"
    (cancel)="cancel.emit()"
  >
    <div class="pause-modal">
      <div class="pause-modal__top">
        <div>
          <h3 class="pause-modal__heading">How long would you like to pause?</h3>
          <p class="pause-modal__hint">
            @if (picking === 'end') {
              Now choose the last day of the pause
            } @else {
              Pick up to 4 months to pause the membership
            }
          </p>
        </div>
        <div class="pause-modal__stepper">
          <button
            type="button"
            class="pause-modal__step"
            aria-label="Pause for fewer months"
            [disabled]="!canStepDown"
            (click)="stepLength(-1)"
          >
            −
          </button>
          <span class="pause-modal__months" aria-live="polite">{{ lengthLabel }}</span>
          <button
            type="button"
            class="pause-modal__step"
            aria-label="Pause for more months"
            [disabled]="!canStepUp"
            (click)="stepLength(1)"
          >
            +
          </button>
        </div>
      </div>

      <div class="pause-modal__calendars">
        @for (calendar of calendars; track calendar.title; let first = $first; let last = $last) {
          <div class="pause-modal__calendar">
            <div class="pause-modal__month-head">
              @if (first) {
                <button
                  type="button"
                  class="pause-modal__nav pause-modal__nav--prev"
                  aria-label="Previous month"
                  [disabled]="!canGoBack"
                  (click)="navigate(-1)"
                >
                  ‹
                </button>
              }
              <span>{{ calendar.title }}</span>
              @if (last) {
                <button
                  type="button"
                  class="pause-modal__nav pause-modal__nav--next"
                  aria-label="Next month"
                  [disabled]="!canGoForward"
                  (click)="navigate(1)"
                >
                  ›
                </button>
              }
            </div>
            <div class="pause-modal__weekdays" aria-hidden="true">
              @for (weekday of weekdays; track $index) {
                <span>{{ weekday }}</span>
              }
            </div>
            @for (week of calendar.weeks; track $index) {
              <div class="pause-modal__week">
                @for (day of week; track $index) {
                  @if (day) {
                    <button
                      type="button"
                      class="pause-modal__day"
                      [class.pause-modal__day--range]="day.inRange"
                      [class.pause-modal__day--edge]="day.isStart || day.isEnd"
                      [disabled]="day.disabled || busy"
                      [attr.aria-pressed]="day.isStart"
                      [attr.aria-label]="day.date | date: 'EEEE, MMMM d, y'"
                      (click)="pickDay(day)"
                    >
                      {{ day.label }}
                    </button>
                  } @else {
                    <span></span>
                  }
                }
              </div>
            }
          </div>
        }
      </div>

      <dl class="pause-modal__summary">
        <div class="pause-modal__stat">
          <dt>Pause starts</dt>
          <dd data-testid="pause-starts">{{ startLabel }}</dd>
        </div>
        <div class="pause-modal__stat">
          <dt>Resumes on</dt>
          <dd data-testid="pause-resumes-on">{{ resumesOnLabel }}</dd>
        </div>
        <div class="pause-modal__stat">
          <dt>Next renewal date</dt>
          <dd data-testid="pause-next-renewal">{{ nextRenewalLabel }}</dd>
        </div>
      </dl>

      @if (errorText) {
        <p class="pause-modal__error" role="alert" data-testid="pause-error">{{ errorText }}</p>
      }
    </div>
  </app-confirm-action-modal>
}
